/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyShekel = createReactComponent("outline", "currency-shekel", "IconCurrencyShekel", [["path", { "d": "M6 18v-12h4a4 4 0 0 1 4 4v4", "key": "svg-0" }], ["path", { "d": "M18 6v12h-4a4 4 0 0 1 -4 -4v-4", "key": "svg-1" }]]);

export { IconCurrencyShekel as default };
//# sourceMappingURL=IconCurrencyShekel.mjs.map
